import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { DialogRef } from '@gelato-api-ui/sdk/src/lib/shared/dialog/dialog-ref';
import { DIALOG_DATA } from '@gelato-api-ui/sdk/src/lib/shared/dialog/dialog-tokens';
import { DialogSize } from '@gelato-api-ui/sdk/src/lib/shared/dialog/types/dialog-size';
import { EProductVariantsUpdateSummary } from '@api-ui-app/src/app/e-commerce-stores/lib/e-product-variants-update-summary';

interface StoreProductVariantsUpdateModalContext {
  productVariantsUpdateSummary: EProductVariantsUpdateSummary;
}

@Component({
  selector: 'gd-store-product-variants-update-modal',
  templateUrl: './store-product-variants-update-modal.component.html',
  styleUrls: ['./store-product-variants-update-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StoreProductVariantsUpdateModalComponent {
  size = DialogSize.Tiny;
  addedVariantTitles: string[] = [];
  removedVariantTitles: string[] = [];

  constructor(
    private readonly dialogRef: DialogRef,
    @Inject(DIALOG_DATA) private readonly dialogData: StoreProductVariantsUpdateModalContext,
  ) {
    this.addedVariantTitles = this.dialogData?.productVariantsUpdateSummary?.added || [];
    this.removedVariantTitles = this.dialogData?.productVariantsUpdateSummary?.removed || [];
  }

  cancel() {
    this.dialogRef.close(false);
  }

  continue() {
    this.dialogRef.close(true);
  }
}
